module.exports = __webpack_public_path__ + "static/media/TD.97c1759b.svg";